/* eslint-disable react/prop-types */
import React from 'react';
import { Flex, Modal } from '@mantine/core';
import Button from '../../elements/Button';

export default function ModalConfirmActivationGIGR({
  opened,
  registrationId,
  onClose,
  onConfirm,
  type = 'diactivated', // 'diactivated' or 'activated'
}) {
  const content = {
    diactivated: {
      title: 'Nonaktifkan Menu GI/GR Pangkalan',
      subtitle: <span>
        Apakah Anda yakin ingin menonaktifkan Pangkalan dengan ID Pangkalan{' '}
        <strong>{registrationId}</strong>?
      </span>,
      action: 'Ya, Nonaktifkan Menu GI/GR',
    },
    activated: {
      title: 'Aktifkan Menu GI/GR Pangkalan',
      subtitle: <span>
        Apakah Anda yakin ingin mengaktifkan Aktivasi Menu GI/GR ke Pangkalan dengan ID Pangkalan{' '}
        <strong>{registrationId}</strong>?
      </span>,
      action: 'Ya, Aktifkan Menu GI/GR',
    },
  };
  return (
    <Modal
      centered={true}
      onClose={onClose}
      opened={opened}
      radius={16}
      size={'lg'}
      styles={{
        body: { padding: '0 30px 30px 30px', fontSize: '18px' },
        header: {
          display: 'flex',
          alignItems: 'flex-start'
        },
        title: {
          padding: '0 15px',
          fontSize: '30px',
          fontWeight: 600,
          lineHeight: '150%',
        },
      }}
      title={content[type].title}
    >
      {content[type].subtitle}
      <Flex gap={8} justify={'space-between'} mt={20}>
        <Button fullWidth onClick={onClose} outlined={true} size={'medium'}>
          Batal
        </Button>
        <Button fullWidth onClick={onConfirm} size={'medium'}>
          {content[type].action}
        </Button>
      </Flex>
    </Modal>
  );
}
